import { gql } from '@apollo/client'

export const BRAND_SOVI_OVER_TIME = gql`
  query BrandSoviOverTime($input: DXOExecutionForZonePathInput!) {
    brandSoviOverTime(input: $input) {
      label
      value
      date
    }
  }
`
